export default {
    tag_ACCRUED_BONUSES: "Эсептелген бонустар",
    tag_ADDRESS: "Бейтаптын дареги",
    tag_ADDRESS_PREDSTAVITEL: "Кардардын өкүлүнүн дареги",
    tag_BIRTHDAY: "Бейтаптын туулган күнү",
    tag_BIRTHDAY_PREDSTAVITEL: "Бейтаптын өкүлүнүн туулган күнү",
    tag_BRANCH_ADDRESS: "Филиалдын дареги",
    tag_BRANCH_BIN: "Филиалдын БИН",
    tag_BRANCH_INN: "Филиалдын ЖСТН",
    tag_BRANCH_KPP: "Филиалдын КПП",
    tag_BRANCH_LICENSE: "Филиалдын лицензиясы",
    tag_BRANCH_OGRN: "Филиалдын НМКН",
    tag_BRANCH_TITLE: "Филиалдын аталышы",
    tag_CARD_CLIENT: "Кардардын картасынын номери",
    tag_CLIENT: "Кардардын аты-жөнү",
    tag_CLIENT_BONUSES: "Кардардын бонустары",
    tag_CLIENT_NAME: "Кардардын аты",
    tag_CLIENT_NAME_MNAME: "Кардардын аты, атасынын аты",
    tag_CLINIC: "Клиниканын аталышы",
    tag_COMPLEX_STATUS: "Дарылоо планы комплексинин статусу",
    tag_COST_DISCOUNTED: "Арзандатууларды эске алуу менен кызмат көрсөтүүлөрдүн наркы",
    tag_COST_ORIGINAL: "Арзандатууларды эске алуусуз кызмат көрсөтүүлөрдүн наркы",
    tag_DATA: "Документтин түзүлгөн датасы",
    tag_DATA_VIZIT: "Визиттин датасы",
    tag_DATE: "Жөнөтмөнүн түзүлгөн датасы",
    tag_DATE_FIRST_VIZIT: "Биринчи визиттин датасы",
    tag_DATE_LAST_VIZIT: "Акыркы визиттин датасы",
    tag_DIAGNOZ: "Диагноз",
    tag_DIAGNOZ_PLAN: "Дарылоо планындагы диагноз",
    tag_DOCTOR: "Аты-жөнү – Дарыгердин аты-жөнү",
    tag_DOCTOR_PHONE: "Дарыгердин телефону",
    tag_DOCUMENT_TYPE_PREDSTAVITEL: "Бейтаптын өкүлүнүн документинин түрү",
    tag_EMAIL_CLIENT: "Кардардын электрондук почтасы",
    tag_FIO_CLIENT: "Кардардын аты-жөнү",
    tag_FIO_DIRECTOR: "Директордун аты-жөнү",
    tag_IIN: "Бейтаптын ЖИН",
    tag_INN: "Бейтаптын ЖСТН",
    tag_LEGAL_ADDRESS: "Клиниканын юридикалык дареги",
    tag_LEGAL_COMPANY_NAME: "Клиниканын юридикалык аталышы",
    tag_LEGAL_NAME: "Юридикалык аталышы",
    tag_LID: "Лидке шилтеме",
    tag_PASSPORT: "Бейтаптын паспортунун номери",
    tag_PASSPORT_CODE: "Бейтаптын паспортунун бөлүмүнүн коду",
    tag_PASSPORT_CODE_PREDSTAVITEL: "Кардардын өкүлүнүн паспортунун бөлүмүнүн коду",
    tag_PASSPORT_DATE: "Бейтаптын паспортунун берилген датасы",
    tag_PASSPORT_DATE_PREDSTAVITEL: "Кардардын өкүлүнүн документинин берилген датасы",
    tag_PASSPORT_ISSUED: "Бейтаптын паспорту ким тарабынан берилген",
    tag_PASSPORT_ISSUED_PREDSTAVITEL: "Кардардын өкүлүнүн документи ким тарабынан берилген",
    tag_PASSPORT_PREDSTAVITEL: "Кардардын өкүлүнүн паспортунун номери",
    tag_PASSPORT_SERIES: "Бейтаптын паспортунун сериясы",
    tag_PASSPORT_SERIES_PREDSTAVITEL: "Кардардын өкүлүнүн документинин сериясы",
    tag_PHONE: "Кардардын телефону",
    tag_PHONE_CLIENT: "Кардардын телефону",
    tag_PHONE_PREDSTAVITEL: "Кардардын өкүлүнүн телефону",
    tag_PLAN_STATUS: "Дарылоо планынын статусу",
    tag_PLAN_TITLE: "Дарылоо планынын аталышы",
    tag_PLAN_TYPE: "Дарылоо планынын түрү",
    tag_PREDSTAVITEL_PACIENTA: "Кардардын өкүлүнүн аты-жөнү",
    tag_SNILS: "Кардардын ЖЭКН",
    tag_SNILS_PREDSTAVITEL: "Кардардын өкүлүнүн ЖЭКН",
    tag_TASK: "Тапшырманын тексти",
    tag_URL_ANKETA: "Бейтаптын анкетасына шилтеме",
    tag_URL_VIZIT_CONFIRMATION: "Визиттин ырастоосуна шилтеме",
    tag_URL_VIZIT_REVIEW: "Визиттин сын-пикирине шилтеме",
    tag_USLUGI: "Кызматтар",
    tag_USLUGI_CLASSIFICATOR: "Классификациялоочу коду бар кызматтар",
    tag_USLUGI_PLAN: "Дарылоо планындагы кызматтар",
    tag_VISIT_DOCTOR: "Визиттин дарыгеринин аты-жөнү",
    tag_ZAKAZ_NARYAD: "Заказ номери жана датасы",
    tag_ZUB: "Тиш(-тер)"
}
